import { FC, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { PdfData } from "@/models/pdfData";
import { useGameDataContext } from "@context/GameDataContext";

const DeleteGameButton: FC<{ storedGame: PdfData }> = ({ storedGame }) => {
  const [open, setOpen] = useState(false);

  const { deleteGame } = useGameDataContext();

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Spiel {storedGame.gameData.gameNumber} löschen?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Alle bisher eingetragenen Challenges werden gelöscht!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Abbrechen</Button>
          <Button
            onClick={() => {
              setOpen(false);
              deleteGame(storedGame.samsId);
            }}
            autoFocus
          >
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
      <Tooltip title={"Spiel löschen"}>
        <IconButton onClick={() => setOpen(true)}>
          <Delete />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default DeleteGameButton;
